import script from "./DynamicAd.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicAd.vue?vue&type=script&setup=true&lang=js"

import "./DynamicAd.vue?vue&type=style&index=0&id=4169bb60&lang=scss"
import "./DynamicAd.vue?vue&type=style&index=1&id=4169bb60&lang=css"

const __exports__ = script;

export default __exports__